module.exports = __webpack_public_path__ + "static/img/8.0235766.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/eng/8.png
// module id = wum7
// module chunks = 0